<script>
  //import DatePicker from "./DatePicker.svelte";
  // import Basic from "components/Flatpickr/Basic.svelte";
  import { Modal } from 'bootstrap';
  import Inline from './Flatpickr/Inline.svelte';
  import ClientList from './TaskDashboard/ClientList.svelte';
  import ClientModal from './TaskDashboard/ClientModal.svelte';
  import { onDestroy } from 'svelte';
  import { client } from 'root/api/index.js';
  export let tabIndex = 1;
  import { customInputEvent, searchKeyByValue, dbDateFormat } from 'components/Helper.js';
  let extraFlag;
  export const setTabIndex = (indexValue, flag) => {
    extraFlag = flag;
    tabIndex = indexValue;
    if (tabIndex == 1 && !(extraFlag != undefined && extraFlag == 'calender')) {
      setTimeout(() => {
        let dashboardData = getDashboardData();
        // inlinePicker.setDate([dashboardData.fromDate,dashboardData.toDate])
      }, 100);
    }
  };

  export const getTabIndex = () => {
    return tabIndex;
  };

  let viewClientModal;
  export const viewAll = (clientFilter) => {
    viewClientModal = new Modal(document.getElementById('viewClientModal'), {
      keyboard: false,
    });
    viewClientModal.show();
    allChecked = false;

    let oldClients = clients;
    oldClients.map((item) => {
      item.checked = false;
      if (clientFilter != undefined && searchKeyByValue(clientFilter, 'id', item.id) != -1) {
        item.checked = true;
      }
      return item;
    });
    clients = oldClients;
    selectedClient = clientFilter != undefined ? clientFilter.length : 0;
  };

  let unitUsers = [];
  let clients = [];
  const getUnitDetail = () => {
    client
      .unitClients({
        units: extraFilter.units.map((item) => {
          item.unitId = item.id;
          return item;
        }),
      })
      .then((response) => {
        clients = response.data.clients;
      });
  };
  let selectedClientId;
  export const checkUrl = (params) => {
    if (params.clientId != undefined) {
      selectedClientId = params.clientId;
      clients = clients.map((item) => {
        if (selectedClientId != undefined && item.id == selectedClientId) {
          item.checked = true;
          selectedClientId = undefined;
          selectedClient = 1;
        }
        return item;
      });
    }
  };

  let extraFilter = { units: [] };
  let selectedClient = 0;
  let allChecked = false;
  let firstTime = true;
  import { dashboardData, getDashboardData, setDashboardData } from '../stores/dashboard.js';
  const unsubscribe = dashboardData.subscribe((state) => {
    client.checkAuth().then(() => {
      if (state != undefined) {
        let dashboardUnit = getDashboardData().units;
        if (firstTime || JSON.stringify(extraFilter.units) != JSON.stringify(dashboardUnit)) {
          extraFilter.units = [...dashboardUnit];
          getUnitDetail();
          firstTime = false;
        }
      }
    });
  });

  export const setOutlookFilter = (params) => {};
  onDestroy(() => {
    unsubscribe();
  });

  const clientFilterRequest = () => {
    let oldClients = clients.filter((item) => item.checked == true);
    selectedClient = oldClients.length;
    setDashboardData({
      ...getDashboardData(),
      clients: oldClients,
    });
  };
  let searchKeyword = '';
  let inlinePicker;
</script>

<!-- <div class="left-panel h-100 d-flex">
<div class="d-flex flex-column h-100 bg-white w-100">

	 {#if tabIndex==1 && !(extraFlag!=undefined && extraFlag=="calender")}
	<div class="calendar-left">
	<div class="calendar-components ">
		<div class="calendar-area w-100 h-100 ">
			<!-- <Basic/> --><!--
			<Inline bind:this={inlinePicker} handleChange={(event)=>{
				setDashboardData({
					...getDashboardData(),
					fromDate:event[0]!=undefined?dbDateFormat(event[0]):"",
					toDate:event[1]!=undefined?dbDateFormat(event[1]):""
				})
			}}/>
		</div>
	</div>
	 <div class="d-flex justify-content-start">
		 <button on:click={()=>{
			inlinePicker.resetDate()
		 }} type="button" class="mt-1 ms-2 reset-filter color-blue d-flex flex-row align-items-center  text-start ms-1 bg-transparent border-0">
			 <img class="icon-14 me-2" alt="" src="/images/reset.svg">
			 Reset
		 </button>
	 </div>
	 </div>
	{/if}
  <div class="page-content">
						<div class="d-flex flex-column h-100">
							 <div class="p-3 search-block">


									<div class="total-customer d-flex flex-row justify-content-between align-items-center">
											<div class="color-blue d-flex flex-row total-member align-items-center ">
												<svg version="1.1" id="Capa_1"  x="0px" y="0px" viewBox="0 0 512 512" style="enable-background:new 0 0 512 512;" xml:space="preserve">
													<g><g><path d="M437.02,330.98c-27.883-27.882-61.071-48.523-97.281-61.018C378.521,243.251,404,198.548,404,148    C404,66.393,337.607,0,256,0S108,66.393,108,148c0,50.548,25.479,95.251,64.262,121.962    c-36.21,12.495-69.398,33.136-97.281,61.018C26.629,379.333,0,443.62,0,512h40c0-119.103,96.897-216,216-216s216,96.897,216,216    h40C512,443.62,485.371,379.333,437.02,330.98z M256,256c-59.551,0-108-48.448-108-108S196.449,40,256,40    c59.551,0,108,48.448,108,108S315.551,256,256,256z"/></g></g></svg>
												<span class="fadeInDown text-muted">{selectedClient} Clients selected</span>
											</div>
											<button class="btn svg-icon pe-0 color-blue border-0 shadow-none bg-transparent font-size-12 svg-icon-success px-0" on:click={(event)=>{
												let oldClients=clients;
												allChecked=!allChecked
												oldClients.map(item=>{
													item.checked=allChecked
													return item;
												})
												clients=oldClients
												clientFilterRequest()
											}}>
											   <img alt="" class="me-1 icon-16" src="/images/checkmark.svg" />
											   {allChecked?"Deselect All":"Select All"}
											</button>
							</div>
							 <div class="position-relative search-client mt-2">
										<img class="position-absolute" alt="" src="/images/search.svg">
										<input type="text" bind:value={searchKeyword} class="form-control mb-0" placeholder="Search Client">
									</div>
							</div>

							<div class="page-content">
								<div class="p-3 pt-0">
									<ul class="list-group list-group-flush">
									{#each clients as item,ikey}
										{#if searchKeyword=="" || item.name.toLowerCase().indexOf(searchKeyword.toLowerCase())!==-1}
											<ClientList name={item.name} item={item} handleChange={(event)=>{
												let oldClients=clients
												oldClients[ikey].checked=event.target.checked;
												clients=oldClients
												clientFilterRequest()
											}} character={item.name.substr(0,1).toUpperCase()}/>
										{/if}
									{/each}
									</ul>

								</div>
							</div>
							<div class="btn-view-all p-2 text-center d-flex flex-row justify-content-between">

										<button on:click={()=>{
											let oldClients=clients;
											oldClients.map(item=>{
												item.checked=false
												return item;
											})
											clients=oldClients
											allChecked=false
											clientFilterRequest()
										}} type="button" class="p-0 reset-filter color-blue d-flex flex-row align-items-center  text-start ms-1 bg-transparent border-0">
											<img class="icon-14 me-2" alt="" src="/images/reset.svg">
											Reset
										</button>

								<button data-bs-toggle="modal" data-bs-target="#viewClientModal" type="button" class="btn btn-link color-blue mb-0 font-size-12 shadow-none border-0 bg-transparent">
									<svg fill="#206bc4" class="mx-1" width="14" height="14" viewBox="0 0 18 18"  xmlns="http://www.w3.org/2000/svg">
										<path d="M8.04898 8.28698L14.299 1.99997L10.709 1.99997L10.709 -2.41836e-05L17.709 -2.47955e-05L17.709 6.99997L15.709 6.99997L15.709 3.41997L9.46399 9.69898L8.04898 8.28698Z" fill="#206bc4"/>
										<path d="M8 1.70599V3.70599H2V15.706H14V9.70599H16V17.706H0V1.70599H8V1.70599Z" fill="#206bc4"/>
										</svg>

									View All
								</button>

							</div>

						</div>


  </div>

</div>
</div> -->

<div
  class="modal fade"
  id="viewClientModal"
  tabindex="-1"
  aria-labelledby="viewClientModalLabel"
  aria-hidden="true"
>
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title font-size-14">Search Client</h5>
        <button
          type="button"
          class="btn-close"
          data-bs-dismiss="modal"
          aria-label="Close"
        ></button>
      </div>
      <div class="modal-body">
        <div class="total-customer d-flex flex-row mb-2 justify-content-between align-items-center">
          <div class="color-blue d-flex flex-row total-member align-items-center">
            <svg
              version="1.1"
              id="Capa_1"
              x="0px"
              y="0px"
              viewBox="0 0 512 512"
              style="enable-background:new 0 0 512 512;"
              xml:space="preserve"
            >
              <g
                ><g
                  ><path
                    d="M437.02,330.98c-27.883-27.882-61.071-48.523-97.281-61.018C378.521,243.251,404,198.548,404,148    C404,66.393,337.607,0,256,0S108,66.393,108,148c0,50.548,25.479,95.251,64.262,121.962    c-36.21,12.495-69.398,33.136-97.281,61.018C26.629,379.333,0,443.62,0,512h40c0-119.103,96.897-216,216-216s216,96.897,216,216    h40C512,443.62,485.371,379.333,437.02,330.98z M256,256c-59.551,0-108-48.448-108-108S196.449,40,256,40    c59.551,0,108,48.448,108,108S315.551,256,256,256z"
                  /></g
                ></g
              ></svg
            >
            <span class="fadeInDown text-muted">{selectedClient} Clients selected</span>
          </div>
          <button
            class="btn svg-icon color-blue border-0 shadow-none bg-transparent font-size-12 svg-icon-success p-0"
            on:click={(event) => {
              let oldClients = clients;
              allChecked = !allChecked;
              oldClients.map((item) => {
                item.checked = allChecked;
                return item;
              });
              clients = oldClients;
              clientFilterRequest();
            }}
          >
            <img
              alt=""
              class="icon-16"
              src="/images/checkmark.svg"
            />
            {allChecked ? 'Deselect All' : 'Select All'}
          </button>
        </div>

        <div class="search-client-input position-relative mb-2">
          <img
            class="position-absolute"
            alt=""
            src="/images/search.svg"
          />
          <input
            type="text"
            class="form-control mb-0"
            bind:value={searchKeyword}
            placeholder="Search Client"
          />
        </div>

        <div class="search-client-list">
          <ul class="list-group list-group-flush mt-2">
            {#each clients as item, ikey}
              {#if searchKeyword == '' || item.name
                  .toLowerCase()
                  .indexOf(searchKeyword.toLowerCase()) !== -1}
                <ClientList
                  name={item.name}
                  item={item}
                  handleChange={(event) => {
                    let oldClients = clients;
                    oldClients[ikey].checked = event.target.checked;
                    clients = oldClients;
                  }}
                  character={item.name.substr(0, 1).toUpperCase()}
                />
              {/if}
            {/each}
          </ul>
        </div>
      </div>
      <div class="modal-footer">
        <button
          type="button"
          class="trans-btn my-0 mx-3 px-4 font-size-12 outline-0 btn-cancel font-size-12"
          data-bs-dismiss="modal">Cancel</button
        >
        <button
          type="button"
          class="btn btn-primary m-0 px-4 font-size-12"
          data-bs-dismiss="modal"
          on:click={() => clientFilterRequest()}>Select</button
        >
      </div>
    </div>
  </div>
</div>

<style type="text/scss">
  .calendar-components {
    height: 300px;
    box-shadow: inset 0 -1px 0 0 rgba(101, 109, 119, 0.16);
  }
  .total-member svg {
    width: 15px;
    height: 15px;
    margin-right: 6px;
  }

  .search-client-list {
    height: 450px;
    overflow: auto;
  }
  .btn-view-all {
    svg {
      position: relative;
      top: -3px;
    }
  }
  .calendar-left {
    border-bottom: 1px solid $input-border-color;
  }
</style>
